  // Initialize read more functionality for quick-add modals
    (function initReadMore() {
      function init() {
        const descriptions = document.querySelectorAll('.product-quick-add__description');
        
        descriptions.forEach(function(description) {
          const btn = description.nextElementSibling;
          
          if (!btn || !btn.classList.contains('read-more-btn')) {
            return;
          }
          
          // Skip if already initialized
          if (btn.hasAttribute('data-initialized')) {
            return;
          }
          btn.setAttribute('data-initialized', 'true');
          
          console.log('Read more initialized');
          
          // Check if content is actually truncated
          function checkTruncation() {
            const lineHeight = parseFloat(getComputedStyle(description).lineHeight) || 24;
            const maxHeight = lineHeight * 3;
            
            if (description.scrollHeight <= maxHeight) {
              btn.classList.add('hidden');
              description.classList.remove('collapsed');
              description.classList.add('expanded');
            } else {
              btn.classList.remove('hidden');
            }
          }
          
          // Toggle read more/less
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            console.log('Read more clicked!');
            
            if (description.classList.contains('collapsed')) {
              description.classList.remove('collapsed');
              description.classList.add('expanded');
              btn.textContent = 'Read Less';
            } else {
              description.classList.remove('expanded');
              description.classList.add('collapsed');
              btn.textContent = 'Read More';
              
              setTimeout(function() {
                description.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
              }, 100);
            }
          });
          
          // Initial check after animations complete
          setTimeout(checkTruncation, 600);
          
          window.addEventListener('resize', checkTruncation);
        });
      }
      
      // Initialize on page load
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }
      
      // Initialize when quick-add modal opens (listen to theme event)
      document.addEventListener('theme:quick-add:open', function() {
        console.log('Quick-add modal opened, initializing read more');
        setTimeout(init, 100);
      });
      
      // Also initialize when modal animation completes
      document.addEventListener('animationend', function(e) {
        if (e.target.classList && e.target.classList.contains('is-animated')) {
          setTimeout(init, 50);
        }
      });
    })();
/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
